import { createContext, useState, useEffect, useMemo } from "react"

export const CartContext = createContext()

export function CartProvider({ children }) {

    const getItemKey = (item) => item.cartKey || item.id

    /* 1. LOAD CART (LocalStorage se data uthana) */
    const [cart, setCart] = useState(() => {
        const savedCart = localStorage.getItem("cart")
        try {
            return savedCart ? JSON.parse(savedCart) : []
        } catch (e) {
            return []
        }
    })

    /* 2. SAVED FOR LATER */
    const [saved, setSaved] = useState([])

    /* 3. MINI CART VISIBILITY */
    const [showCart, setShowCart] = useState(false)

    /* 4. SAVE TO LOCALSTORAGE (Jab bhi cart badle) */
    useEffect(() => {
        localStorage.setItem("cart", JSON.stringify(cart))
    }, [cart])

    /* 5. CALCULATE TOTAL ITEMS (Header badge ke liye) */
    // useMemo use kiya hai taaki calculation baar-baar na ho
    const totalItems = useMemo(() => {
        return cart.reduce((acc, item) => acc + (item.quantity || item.qty || 0), 0)
    }, [cart])

    /* 6. ADD TO CART */
    function addToCart(product, qty = 1) {
        setCart(prev => {
            const productKey = getItemKey(product)
            const exist = prev.find(item => getItemKey(item) === productKey)
            
            // Safety Check: Price nikalne ke liye
            const finalPrice = product.price || product.regular_price || 0;

            if (exist) {
                return prev.map(item =>
                    getItemKey(item) === productKey 
                        ? { ...item, quantity: (item.quantity || item.qty || 0) + qty, qty: (item.qty || item.quantity || 0) + qty } 
                        : item
                )
            }
            
            // Naya item add karte waqt quantity aur qty dono set karein
            return [...prev, { ...product, price: finalPrice, quantity: qty, qty: qty }]
        })
        setShowCart(true)
    }

    /* 7. REMOVE FROM CART */
    function removeFromCart(id) {
        setCart(prev => prev.filter(item => getItemKey(item) !== id))
    }

    /* 8. UPDATE QUANTITY */
    function updateQty(id, newQty) {
        if (newQty < 1) return
        setCart(prev =>
            prev.map(item =>
                getItemKey(item) === id ? { ...item, quantity: newQty, qty: newQty } : item
            )
        )
    }

    /* 9. CLEAR CART */
    function clearCart() {
        setCart([])
    }

    /* 10. SAVE FOR LATER */
    function saveForLater(product) {
        setSaved(prev => [...prev, product])
        setCart(prev => prev.filter(item => getItemKey(item) !== getItemKey(product)))
    }

    /* 11. MOVE BACK TO CART */
    function moveToCart(product) {
        addToCart(product)
        setSaved(prev => prev.filter(item => getItemKey(item) !== getItemKey(product)))
    }

    return (
        <CartContext.Provider
            value={{
                cart,
                totalItems, // 👈 Ye ab aap Header.js mein use kar sakte hain
                addToCart,
                removeFromCart,
                updateQty,
                clearCart,
                saved,
                saveForLater,
                moveToCart,
                showCart,
                setShowCart
            }}
        >
            {children}
        </CartContext.Provider>
    )
}
